import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookiesEditModalComponent } from './cookies-edit-modal.component';
import { FormsModule } from '@angular/forms';
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {MatRadioModule} from "@angular/material/radio";

@NgModule({
    declarations: [
        CookiesEditModalComponent,
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatRadioModule,
        FormsModule,
    ],
    exports: [
        CookiesEditModalComponent,
    ]
})
export class CookiesEditModalModule {
}
